import * as Configuration from '../app.constants.js';

miscConfig.$inject = ['$animateProvider',  '$uiViewScrollProvider', '$translateProvider', '$ariaProvider', 'tmhDynamicLocaleProvider', '$provide'];
export function miscConfig($animateProvider,  $uiViewScrollProvider, $translateProvider, $ariaProvider, tmhDynamicLocaleProvider, $provide) {


  // An exception occured. 
  $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
    // Note: we use $injector here because if we do not, we get a circular dependency
    return function (exception, cause) {
      $delegate(exception, cause);
      let AlertingFactory = $injector.get('AlertingFactory');
      AlertingFactory.error('an-exception-occured')
    };
  }]);


  // make sure we do not force a visual scroll to the state we just navigated to
  $uiViewScrollProvider.useAnchorScroll();

  // If anyone knows what the following 2 lines do, please feel free to update this comment --Pascal
  $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
  tmhDynamicLocaleProvider.localeLocationPattern('ajs-assets/angular-i18n/angular-locale_{{locale}}.js');


  // cf https://www.bennadel.com/blog/2935-enable-animations-explicitly-for-a-performance-boost-in-angularjs.htm
  // On the metrics page, the following line *halves* the CPU time spent building the table with ng-repeats
  $animateProvider.classNameFilter(/alc-ng-animated/);


  // ng-aria configuration to prevent focusing divs ans spans (which displays an unattractive blue outline at lest in Chrome)
  $ariaProvider.config({
    tabindex: false
  });

  // Work around https://github.com/angular/material/issues/6495 
  // (on Chrome, using the mouse wheel when the cursor is over the tab disables the paginating arrows)
  try {
    angular.element.event.mouseHooks.props.push('wheelDelta');
  } catch (e) {
    console.warn('exception while trying to configure jQuery events:', e);
  }
  
}
